<template>
  <div class="my-wallet-content ali">
    <div class="account">
      <img src="../imgs/jzp-wallet.png" alt="">
      <div class="account-btns">
        <el-button size="small" type="primary" @click="toBankCardPage">
          入账银行卡
        </el-button>
        <el-button size="small" type="primary" @click="handleReflect">
          提现
        </el-button>
        <el-button size="small" type="primary" @click="toChargePage">
          充值
        </el-button>
      </div>
    </div>

    <div class="account-money">
      <div class="account-money-item">
        <div class="title">
          可用余额(元)
        </div>
        <div class="money">
          {{ isNull(data?.availableBalance) ? '--' : data?.availableBalance }}
        </div>
      </div>
    </div>

    <div class="account-info">
      <div class="left">
        <div class="account-info-title">
          <span class="label">服务商：</span>
          <span class="value">{{ isNull(data?.serverName) ? '--' : data?.serverName }}</span>
        </div>
        <div class="account-info-title">
          <span class="label">账&nbsp;&nbsp;&nbsp;户：</span>
          <span class="value">{{ isNull(data?.accountNo) ? '--' : data?.accountNo }}</span>
        </div>
      </div>

      <alipay-book-charge 
        :visible="showChargeDialog" 
        :data="data" 
        @close="showChargeDialog = false" 
        @confirm="emit('reload')"
      />

      <alipay-book-withdraw 
        :visible="showWithdrawDialog" 
        :data="data" 
        :pay-phone="String(payInfo?.payPhone)" 
        :loading="withdrawLoading" 
        @close="showWithdrawDialog = false" 
        @confirm="handleWithdraw"
      />
    </div>
  </div>
</template>

<script setup lang='ts'>
import AlipayBookCharge from '@core/main/src/modules/finance/wallets/alipay-book/alipay-book-charge.vue';
import AlipayBookWithdraw from '@core/main/src/modules/finance/wallets/alipay-book/alipay-book-withdraw.vue';
import { onConfirm } from '@vue3/components';
import { inject, Ref, ref, nextTick } from 'vue';
import { IFinanceWallet } from '@core/main/types/finance';
import { isNull } from '@core/tools';
import { withdrawAlipayUnit } from '@core/main/api';
import { ElMessage } from 'element-plus';
import { EHasPayPassword, IAlipayUnitWithdrawRequest, ISecuritySettingDetail } from '@core/main/types';
import { useRouter } from 'vue-router';

const emit = defineEmits(['reload']);
const router = useRouter();

const data = inject<Ref<IFinanceWallet>>('data');
const payInfo = inject<Ref<ISecuritySettingDetail>>('payInfo');

const withdrawLoading = ref(false);
const showWithdrawDialog = ref(false);
const showChargeDialog = ref(false);

function handleReflect() {
  if (payInfo.value?.hasPayPassword === EHasPayPassword.NOT_SET) {
    onConfirm({
      message: '您未设置支付密码，请前往设置！',
      okText: '去设置',
      onOk: async () => {
        router.push({ name: 'SecuritySettings' });
      },
    });
    return;
  }

  if (data.value?.alipayUnitBankAccountList?.length === 0) {
    onConfirm({
      message: '您没有添加入账银行卡，无法完成提现',
      okText: '去添加',
      onOk: async () => {
        router.push({
          name: 'FinanceIncomingAccount',
          query: { serverId: data.value?.serverId },
        });
      },
    });
    return;
  }

  showWithdrawDialog.value = true;
}

function toBankCardPage() {
  router.push({
    name: 'FinanceIncomingAccount',
    query: { serverId: data.value?.serverId },
  });
}

function toChargePage() {
  if (data.value?.alipayUnitBankAccountList?.length === 0) {
    onConfirm({
      message: '您没有添加入账银行卡，无法完成充值',
      okText: '去添加',
      onOk: async () => {
        router.push({
          name: 'FinanceIncomingAccount',
          query: { serverId: data.value?.serverId },
        });
      },
    });
    return;
  }
  showChargeDialog.value = true;
}

async function handleWithdraw(params: IAlipayUnitWithdrawRequest) {
  console.log(params);
  showWithdrawDialog.value = false;
  withdrawLoading.value = true;

  try {
    await withdrawAlipayUnit(params);

    ElMessage.success('提现成功');
    showWithdrawDialog.value = false;

    nextTick(() => {
      emit('reload');
    });
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  withdrawLoading.value = false;
}
</script>

<style lang="scss" scoped src="../style/my-wallet.scss" />